/* ============================================
   BRAIN BEAR - Global Scripts
   ============================================ */

// Force scroll to top on page load/refresh
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

document.addEventListener('DOMContentLoaded', () => {

  /* --- Sticky Header: transparent at top, solid on scroll --- */
  const header = document.getElementById('site-header');
  if (header) {
    let ticking = false;

    function onScroll() {
      var announcementH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
      var triggerPoint = announcementH + headerH;

      var announcement = document.querySelector('.announcement-bar');
      if (window.scrollY > triggerPoint) {
        header.classList.add('is-scrolled');
        if (announcement) announcement.classList.add('is-hidden');
      } else {
        header.classList.remove('is-scrolled');
        if (announcement) announcement.classList.remove('is-hidden');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Smooth Scroll for Anchor Links --- */
  document.querySelectorAll('a[data-scroll], [data-scroll]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href) return;
      // Extract hash from href (handles both "#section" and "/#section")
      let hash = null;
      if (href.startsWith('#')) {
        hash = href;
      } else if (href.startsWith('/#')) {
        hash = href.substring(1);
      }
      if (hash) {
        const target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
          const announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
          const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - announcementHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
        // If target not found (different page), let the browser navigate to /#section
      }
    });
  });

  /* --- Mobile Menu --- */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileClose = document.getElementById('mobile-menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');

  function openMobile() {
    mobileMenu?.classList.add('is-open');
    mobileOverlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    mobileToggle?.setAttribute('aria-expanded', 'true');
    mobileMenu?.setAttribute('aria-hidden', 'false');
  }

  function closeMobile() {
    mobileMenu?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    mobileToggle?.setAttribute('aria-expanded', 'false');
    mobileMenu?.setAttribute('aria-hidden', 'true');
  }

  mobileToggle?.addEventListener('click', openMobile);
  mobileClose?.addEventListener('click', closeMobile);
  mobileOverlay?.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-mobile-close]').forEach(link => {
    link.addEventListener('click', () => {
      setTimeout(closeMobile, 100);
    });
  });

  /* --- Scroll-triggered Animations --- */
  const animElements = document.querySelectorAll('[data-animate]');
  if (animElements.length > 0) {
    const animObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animElements.forEach(el => animObserver.observe(el));
  }

  /* --- Cart Toggle --- */
  const cartToggle = document.getElementById('cart-toggle');
  cartToggle?.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent('cart:toggle'));
  });
});
